<template>
  <div class="clients-container">

    <base-navigation></base-navigation>

    <!-- Top Header Card -->
    <div class="top-card">

      <div class="title-section">
        <h2>Loan Clients</h2>
        <span class="count">{{ clients.length }} Clients</span>
      </div>

      <button
        @click="$router.push('/create/loan/client')"
        class="new-client-btn"
      >
        + Register Client
      </button>

    </div>

    <!-- Main Card -->
    <div class="card">

      <!-- Loading -->
      <div v-if="loading" class="state loading">
        Loading clients...
      </div>

      <!-- Table -->
      <div v-else class="table-wrapper">

        <table class="clients-table">

          <thead>
            <tr>
              <th>Client</th>
              <th>ID Number</th>
              <th>Phone</th>
              <th>Email</th>
              <th>Loan Limit</th>
              <th>Bank</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            <tr
              v-for="(client) in clients"
              :key="client.id"
            >

             

              <td class="client-cell">

                <div class="avatar">
                  {{ client.id }}
                </div>

                <div class="client-info">
                  <div class="name">
                    {{ client.client_name }}
                  </div>
                </div>

              </td>

              <td>{{ client.idNumber }}</td>

              <td>{{ client.phone_number }}</td>

              <td class="email">
                {{ client.email || '—' }}
              </td>

              <td>
                <span class="limit-badge">
                  {{ formatMoney(client.loan_limit) }}
                </span>
              </td>

              <td>{{ client.bank }}</td>

              <td>
                <button
                  class="assign-btn"
                  @click="assignLoan(client)"
                >
                  Loan
                </button>
              </td>

            </tr>

            <tr v-if="clients.length === 0">
              <td colspan="8" class="state">
                No clients found
              </td>
            </tr>

          </tbody>

        </table>

      </div>

    </div>

  </div>
</template>

<script>
import axios from "axios";

export default {

  name: "LoanClientsList",

  data() {
    return {
      clients: [],
      loading: false
    };
  },

  mounted() {
    this.fetchClients();
  },

  methods: {

    async fetchClients() {

      this.loading = true;

      try {

        const response = await axios.get(
          "https://api.roberms.com/raisetrack/get/loan/clients"
        );

        this.clients = response.data;

      }
      catch (error) {

        console.error(error);

      }
      finally {

        this.loading = false;

      }

    },

    assignLoan(client) {

      this.$router.push({
        path: "/new/loan",
        query: {
          client_id: client.id
        }
      });

    },

    formatMoney(amount) {

      if (!amount) return "KES 0";

      return "KES " + Number(amount).toLocaleString();

    },

    getInitials(name) {

      if (!name) return "?";

      const parts = name.split(" ");

      return parts.length > 1
        ? parts[0][0] + parts[1][0]
        : parts[0][0];

    }

  }

};
</script>

<style scoped>

.clients-container {

  padding: 20px;
  background: #f4f6f9;
  min-height: 100vh;

}

/* Header Card */

.top-card {

  background: white;
  padding: 15px 20px;
  border-radius: 10px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  box-shadow: 0 2px 8px rgba(0,0,0,0.05);

  margin-bottom: 15px;

}

.title-section {

  display: flex;
  align-items: center;
  gap: 10px;

}

.count {

  background: #e3f2fd;
  color: #1976d2;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;

}

/* Button */

.new-client-btn {

  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;

  transition: 0.2s;

}

.new-client-btn:hover {

  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);

}

/* Card */

.card {

  background: white;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);

}

/* Table */

.table-wrapper {

  overflow-x: auto;

}

.clients-table {

  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

}

.clients-table th {

  text-align: left;
  padding: 10px;
  background: #fafafa;
  color: #555;

}

.clients-table td {

  padding: 10px;
  border-bottom: 1px solid #eee;

}

.clients-table tr:hover {

  background: #f9fbff;

}

/* Client Cell */

.client-cell {

  display: flex;
  align-items: center;
  gap: 10px;

}

.avatar {

  width: 32px;
  height: 32px;
  border-radius: 50%;

  background: linear-gradient(135deg, #1976d2, #42a5f5);
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 12px;
  font-weight: bold;

}

/* Loan Limit */

.limit-badge {

  background: #e8f5e9;
  color: #2e7d32;
  padding: 4px 10px;
  border-radius: 20px;
  font-weight: bold;
  font-size: 12px;

}

/* Assign Button */

.assign-btn {

  background: #16a34a;
  color: white;
  border: none;
  padding: 5px 12px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;

}

.assign-btn:hover {

  background: #15803d;

}

/* States */

.state {

  text-align: center;
  padding: 20px;
  color: #666;

}

.loading {

  color: #1976d2;

}

.index {

  font-weight: bold;
  color: #1976d2;

}

.email {

  color: #666;

}

</style>